import { render } from "./SplashScreen.vue?vue&type=template&id=03807d80&ts=true"
import script from "./SplashScreen.vue?vue&type=script&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./SplashScreen.vue?vue&type=style&index=1&id=03807d80&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__